import { useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import Start_Btn from "../../common/start-btn/Start_Btn";
import "./Login_Modal.css";
import Cookies from "js-cookie";
import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { sendLoginOtp, LoginverifyOtp } from "../../../features/auth/Slice";
import { IDS } from "../../../utils/IDS";
import { Getprofile } from "../../../redux/profile";

const Login_Modal = ({ show, handleClose, handleLogin }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [timer, setTimer] = useState(0);
  const [canResend, setCanResend] = useState(false);
  const [showLoginBtn, setShowLoginBtn] = useState(false);
  const [otp, setOtp] = useState("");
  const [contact_no, setContact_no] = useState("");
  const [otpError, setOtpError] = useState("");
  const { sendLoginOtpStatus, verifyLoginOtpStatus } = useSelector(
    (state) => state?.auth?.login,
  );

  useEffect(() => {
    if (show) {
      setContact_no("");
      setOtp("");
      setOtpError("");
      setShowLoginBtn(false);
      setTimer(0);
      setCanResend(false);
    }
  }, [show]);

  // SEND OTP
  const handleSendOtp = async () => {
    const response = await dispatch(sendLoginOtp({ contact_no }));
    if (response?.payload?.success) {
      setShowLoginBtn(true);
      setTimer(60);
    } else {
      alert("Failed to send OTP");
    }
  };

  const handleResendOtp = () => {
    handleSendOtp();
  };

  useEffect(() => {
    if (timer <= 0) {
      setCanResend(true);
      return;
    }

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  // VERIFY OTP (LOGIN)
  const handleVerifyOtp = async () => {
    const response = await dispatch(LoginverifyOtp({ contact_no, otp }));

    console.log(response?.payload?.data?.token, "tokennnnn");

    if (response?.payload?.success) {
      handleLogin();
      handleClose();
      Cookies.set(
        "excellent_website_security",
        response?.payload?.data?.token,
        {
          expires: 7,
          secure: false,
        },
      );

      navigate("/profile");
      dispatch(Getprofile({}));
    } else {
      //alert("Invalid OTP");
      setOtpError("Invalid OTP");
    }
  };

  const [error, setError] = useState("");

  const handleChange = (e) => {
    let value = e.target.value;

    // ✅ Allow only numbers
    value = value.replace(/[^0-9]/g, "");

    // ✅ Limit to 10 digits
    if (value.length > 10) return;

    setContact_no(value);

    // ✅ Validation
    if (value.length === 0) {
      setError("Contact is required");
    } else if (value.length < 10) {
      setError("Please enter a valid 10-digit contact");
    } else {
      setError("");
    }
  };

  return (
    <Modal className="login_modal" size="lg" show={show} onHide={handleClose} centered>
      <Modal.Body className="counselling_modal">
        <div className="modal_header">
          <h5 className="modal_title">Login to Continue Your Career Journey</h5>

          <div className="close_div">
            <img
              src="/assets/images/home_banner/close.png"
              alt="close-btn"
              className="close_btn"
              onClick={handleClose}
            />
          </div>
        </div>

        <Form onSubmit={(e) => e.preventDefault()}>
          <Row>
            <Col md={6} sm={6}>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="tel"
                  value={contact_no}
                  onChange={handleChange}
                  maxLength={10}
                  isInvalid={!!error}
                  placeholder="Enter your contact"
                />

                {error && (
                  <Form.Control.Feedback type="invalid">
                    {error}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>

            <Col md={6} sm={6}>
              <Form.Group className="mb-3">
                <Form.Label>OTP</Form.Label>
                <div className="otp_wrapper">
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={4}
                    renderInput={(props) => (
                      <input {...props} className="otp_input_box" />
                    )}
                  />
                </div>
                {otpError && <p className="text-danger mt-1">{otpError}</p>}
              </Form.Group>
            </Col>
          </Row>

          {/* <div className="btns_holder">
            {!showLoginBtn ? (
              <Start_Btn
                text={
                  sendLoginOtpStatus === IDS.SLICESTATUS.Loading
                    ? "Sending..."
                    : "Get OTP"
                }
                onClick={handleSendOtp}
              />
            ) : (
              <Start_Btn
                text={
                  verifyLoginOtpStatus === IDS.SLICESTATUS.Loading
                    ? "Logging in..."
                    : "Login"
                }
                onClick={handleVerifyOtp}
              />
              
            )}
          </div> */}

          <div className="btns_holder">
            {/* First Step – Get OTP */}
            {!showLoginBtn ? (
              <Start_Btn
                text={
                  sendLoginOtpStatus === IDS.SLICESTATUS.Loading
                    ? "Sending..."
                    : "Get OTP"
                }
                onClick={handleSendOtp}
              />
            ) : (
              <>
                {/* WHEN TIMER IS RUNNING → SHOW LOGIN + TIMER */}
                {timer > 0 && (
                  <>
                  <p className="otp-timer"> OTP valid for {timer}s</p>
                    <Start_Btn
                      text={
                        verifyLoginOtpStatus === IDS.SLICESTATUS.Loading
                          ? "Logging in..."
                          : "Login"
                      }
                      onClick={handleVerifyOtp}
                    />

                    
                  </>
                )}

                {/* WHEN TIMER ENDS → SHOW RESEND OTP ONLY */}
                {timer === 0 && (
                  <Start_Btn text="Resend OTP" onClick={handleSendOtp} />
                )}
              </>
            )}
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default Login_Modal;

// import { useState } from "react";
// import { Col, Form, Modal, Row } from "react-bootstrap";
// import OtpInput from "react-otp-input";
// import { useNavigate } from "react-router-dom";
// import Start_Btn from "../../common/start-btn/Start_Btn";
// import "./Login_Modal.css";

// const Login_Modal = ({ show, handleClose, handleLogin }) => {
//   const navigate = useNavigate();
//   const [showLoginBtn, setShowLoginBtn] = useState(false);
//   const [otp, setOtp] = useState("");

//   return (
//     <Modal show={show} onHide={handleClose} centered>
//       <Modal.Body className="counselling_modal">
//         <div className="modal_header">
//           <h5 className="modal_title">Login to Continue Your Career Journey</h5>

//           <div className="close_div">
//             <img
//               src="/assets/images/home_banner/close.png"
//               alt="close-btn"
//               className="close_btn"
//               onClick={handleClose}
//             />
//           </div>
//         </div>

//         <Form onSubmit={(e) => e.preventDefault()}>
//           <Row>
//             <Col md={6} sm={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Phone Number</Form.Label>
//                 <Form.Control type="text" />
//               </Form.Group>
//             </Col>

//             <Col md={6} sm={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>OTP</Form.Label>
//                 <div className="otp_wrapper">
//                   <OtpInput
//                     value={otp}
//                     onChange={setOtp}
//                     numInputs={4}
//                     renderInput={(props) => (
//                       <input {...props} className="otp_input_box" />
//                     )}
//                   />
//                 </div>
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="btns_holder">
//             {!showLoginBtn ? (
//               <Start_Btn text="Get OTP" onClick={() => setShowLoginBtn(true)} />
//             ) : (
//               <Start_Btn
//                 text="Login"
//                 onClick={() => {
//                   handleLogin();
//                   handleClose();
//                 }}
//               />
//             )}
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default Login_Modal;
